<div mat-dialog-content class="contant-dialog">
    <p>בכיתה קיימים תלמידים בעלי מערכת שעות פרטית</p>
    <p>?אם ברצונך לקשר אותם למערכת שעות זו</p>
    <!-- <mat-form-field appearance="fill">
    <mat-label>Favorite Animal</mat-label>
    <input matInput [(ngModel)]="data.animal">
  </mat-form-field> -->
</div>
<div mat-dialog-actions>
    <button class="cancel-save-button" (click)="dialogRef.close()">ביטול</button>
    <button class="button save-button" [mat-dialog-close]="false">לא</button>
    <button class="button save-button blue" [mat-dialog-close]="true">כן</button>
</div>